module.exports = __webpack_public_path__ + "img/btn-btn-next-dn.7af198c9.svg";